import { useQuery } from "@tanstack/react-query";

import { marketplaceApi } from "@/features/marketplace/services/marketplace.api";

export function useFeaturedProducts() {
  return useQuery({
    queryKey: ["products", "featured"],
    queryFn: marketplaceApi.getFeaturedProducts,
  });
}
